// @ts-nocheck: converted from JS

export const DraggableTypes = {
  card: 'CARD',
};
